export const countries = [
  'Argentina',
  'Bolivia',
  'Brazil',
  'Chile',
  'Colombia',
  'Ecuador',
  'Guyana',
  'Guyana Francesa',
  'Mexico',
  'Paraguay',
  'Peru',
  'Uruguay',
  'Venezuela',
  'Suriname',
  'Otro'
]